import {
  IBXPExpressClient,
  BXPExpressClient
} from '@atlassiansox/bxp-express-client';
import React, { createContext, PropsWithChildren, useContext } from 'react';

const BXPExpressClientContext = createContext<IBXPExpressClient>(
  new BXPExpressClient()
);

export function useBXPExpressClient(): IBXPExpressClient {
  return useContext(BXPExpressClientContext);
}

export type BXPExpressClientProviderProps = PropsWithChildren<{
  readonly client: IBXPExpressClient;
}>;

export function BXPExpressClientProvider({
  client,
  children
}: BXPExpressClientProviderProps) {
  return (
    <BXPExpressClientContext.Provider value={client}>
      {children}
    </BXPExpressClientContext.Provider>
  );
}
